import { getFincaraizNavCities } from "RefactorSearchPage/Header/fincaraizNav.config";

export type NeighborhoodLink = {
	label: string;
	url: string;
};

export type CityNeighborhoods = {
	city: string;
	image: string;
	imageUrl?: string;
	cityUrl: string;
	neighborhoods: NeighborhoodLink[];
};

const ventaCityUrls = Object.fromEntries(
	getFincaraizNavCities().venta.map(({ label, href }) => [label, href])
);

const CITY_IMAGES = {
	bogota: "https://cdn1.infocasas.com.uy/web/6a46b1350ea27_bogo.png",
	medellin: "https://cdn1.infocasas.com.uy/web/6a46b112bfed6_mede.png",
	cali: "https://cdn1.infocasas.com.uy/web/6a46b023e6ef7_cali.png",
	barranquilla: "https://cdn1.infocasas.com.uy/web/6a46b112f1c26_barra.png",
};

const CITY_BLOG_URLS = {
	bogota: "https://www.fincaraiz.com.co/blog/bogota/",
	medellin: "https://www.fincaraiz.com.co/blog/medellin/",
	cali: "https://www.fincaraiz.com.co/blog/cali/",
	barranquilla: "https://www.fincaraiz.com.co/blog/barranquilla/",
};

const CITY_IMAGE_BLOG_URLS = {
	bogota: "https://www.fincaraiz.com.co/blog/vivir-en-bogota-dc-como-es/",
	medellin: "https://www.fincaraiz.com.co/blog/vivir-en-medellin/",
	cali: "https://www.fincaraiz.com.co/blog/vivir-en-cali-como-es/",
	barranquilla:
		"https://www.fincaraiz.com.co/blog/como-es-vivir-en-barranquilla/",
};

export const FINCARAIZ_NEIGHBORHOODS_BY_CITY: CityNeighborhoods[] = [
	{
		city: "Bogotá",
		image: CITY_IMAGES.bogota,
		imageUrl: CITY_IMAGE_BLOG_URLS.bogota,
		cityUrl: CITY_BLOG_URLS.bogota,
		neighborhoods: [
			{
				label: "Antonio Nariño",
				url: "https://www.fincaraiz.com.co/blog/localidad-antonio-narino-bogota/",
			},
			{
				label: "Barrios Unidos",
				url: "https://www.fincaraiz.com.co/blog/barrios-unidos-bogota-comercio-y-calidad/",
			},
			{
				label: "Bosa",
				url: "https://www.fincaraiz.com.co/blog/bosa-barrios-crecimiento-inmobiliario/",
			},
			{
				label: "Chapinero",
				url: "https://www.fincaraiz.com.co/blog/chapinero-bogota-cultura-barrios-mercado/",
			},
			{
				label: "Engativa",
				url: "https://www.fincaraiz.com.co/blog/engativa-bogota-barrios-servicios/",
			},
			{
				label: "Fontibon",
				url: "https://www.fincaraiz.com.co/blog/fontibon-importante-localidad-logistica/",
			},
			{
				label: "Kennedy",
				url: "https://www.fincaraiz.com.co/blog/kennedy-bogota-mercado-inmobiliario/",
			},
			{
				label: "Los Martires",
				url: "https://www.fincaraiz.com.co/blog/los-martires-mercado-inmobiliario/",
			},
			{
				label: "Puente Aranda",
				url: "https://www.fincaraiz.com.co/blog/puente-aranda/",
			},
			{
				label: "San Cristobal",
				url: "https://www.fincaraiz.com.co/blog/san-cristobal-mercado-inmobiliario/",
			},
			{
				label: "Santa Fe",
				url: "https://www.fincaraiz.com.co/blog/santa-fe-bogota-historia-patrimonio/",
			},
			{
				label: "Suba",
				url: "https://www.fincaraiz.com.co/blog/suba-bogota-barrios-desarrollo-urbano/",
			},
			{
				label: "Teusaquillo",
				url: "https://www.fincaraiz.com.co/blog/teusaquillo-bogota-arquitectura/",
			},
			{
				label: "Tunjuelito",
				url: "https://www.fincaraiz.com.co/blog/tunjuelito-mercado-inmobiliario/",
			},
			{
				label: "Usaquen",
				url: "https://www.fincaraiz.com.co/blog/usaquen-localidad-bogota-barrios-mercado/",
			},
			{
				label: "Usme",
				url: "https://www.fincaraiz.com.co/blog/usme-bogota-barrios-mercado-inmobiliario/",
			},
			{
				label: "Los Rosales",
				url: "https://www.fincaraiz.com.co/blog/los-rosales-exclusividad-y-tranquilidad/",
			},
			{
				label: "Chicó Navarra",
				url: "https://www.fincaraiz.com.co/blog/conoce-el-barrio-chico-navarra/",
			},
			{
				label: "San Patricio",
				url: "https://www.fincaraiz.com.co/blog/asi-es-san-patricio-en-bogota/",
			},
			{
				label: "Chicó Reservado",
				url: "https://www.fincaraiz.com.co/blog/por-que-elegir-a-chico-reservado/",
			},
			{
				label: "Cedritos",
				url: "https://www.fincaraiz.com.co/blog/los-cedritos-comodidad-en-usaquen/",
			},
			{
				label: "Santa Paula",
				url: "https://www.fincaraiz.com.co/blog/santa-paula-el-corazon-de-usaquen/",
			},
			{
				label: "Santa Barbara Alta",
				url: "https://www.fincaraiz.com.co/blog/santa-barbara-alta-lujo-en-usaquen/",
			},
			{
				label: "Santa Barbara Centro",
				url: "https://www.fincaraiz.com.co/blog/santa-barbara-centro-candelaria-bogota/",
			},
			{
				label: "El Virrey",
				url: "https://www.fincaraiz.com.co/blog/por-que-elegir-el-virrey-para-invertir/",
			},
			{
				label: "Multicentro",
				url: "https://www.fincaraiz.com.co/blog/multicentro-seguridad-y-bienestar/",
			},
			{
				label: "Calleja Baja",
				url: "https://www.fincaraiz.com.co/blog/calleja-baja-inversion-en-usaquen/",
			},
			{
				label: "La Suiza",
				url:
					"https://www.fincaraiz.com.co/blog/la-suiza-tranquilidad-exclusiva-a-un-paso-del-ritmo-urbano-de-armenia/",
			},
			{
				label: "Bosques del Marqués",
				url: "https://www.fincaraiz.com.co/blog/bosques-del-marques/",
			},
			{
				label: "Santa Bibiana",
				url: "https://www.fincaraiz.com.co/blog/santa-bibiana/",
			},
			{
				label: "Bellavista",
				url: "https://www.fincaraiz.com.co/blog/bellavista-occidental-engativa-bogota/",
			},
			{
				label: "Navarra",
				url: "https://www.fincaraiz.com.co/blog/condominio-navarra/",
			},
			{
				label: "Centro Internacional",
				url: "https://www.fincaraiz.com.co/blog/centro-internacional/",
			},
			{
				label: "Lagos de Torca",
				url: "https://www.fincaraiz.com.co/blog/lagos-de-torca/",
			},
			{
				label: "La Cabrera",
				url: "https://www.fincaraiz.com.co/blog/la-cabrera/",
			},
			{
				label: "La Porciuncula",
				url: "https://www.fincaraiz.com.co/blog/la-porciuncula/",
			},
			{
				label: "El Retiro",
				url: "https://www.fincaraiz.com.co/blog/el-retiro/",
			},
			{
				label: "Quinta Camacho",
				url: "https://www.fincaraiz.com.co/blog/quinta-camacho/",
			},
			{
				label: "Santa Barbara Oriental",
				url: "https://www.fincaraiz.com.co/blog/santa-barbara-oriental/",
			},
			{
				label: "Molinos norte",
				url: "https://www.fincaraiz.com.co/blog/molinos-norte/",
			},
			{
				label: "Bosque de pinos",
				url: "https://www.fincaraiz.com.co/blog/bosque-de-pinos-usaquen/",
			},
			{
				label: "Ciudad salitre",
				url: "https://www.fincaraiz.com.co/blog/ciudad-salitre-oriental-en-bogota/",
			},
			{
				label: "El Nogal",
				url: "https://www.fincaraiz.com.co/blog/el-nogal/",
			},
			{
				label: "Las nieves",
				url: "https://www.fincaraiz.com.co/blog/las-nieves/",
			},
			{
				label: "Rincón del chico",
				url: "https://www.fincaraiz.com.co/blog/barrio-rincon-del-chico-en-chapinero/",
			},
			{
				label: "La calleja",
				url: "https://www.fincaraiz.com.co/blog/barrio-la-calleja-en-usaquen/",
			},
			{
				label: "El Refugio",
				url:
					"https://www.fincaraiz.com.co/blog/vivir-en-las-alturas-el-encanto-residencial-y-la-paz-de-el-refugio/",
			},
			{
				label: "Nuevo Country",
				url: "https://www.fincaraiz.com.co/blog/nuevo-country-estilo-de-vida-exclusivo/",
			},
			{
				label: "Antiguo Country",
				url: "https://www.fincaraiz.com.co/blog/antiguo-country-tradicion-en-chapinero/",
			},
			{
				label: "Chapinero Central",
				url: "https://www.fincaraiz.com.co/blog/chapinero-central-en-bogota/",
			},
			{
				label: "Bosque de Maria",
				url: "https://www.fincaraiz.com.co/blog/bosque-de-maria-en-usaquen/",
			},
			{
				label: "Alhambra",
				url: "https://www.fincaraiz.com.co/blog/alhambra-zona-para-estandares-elevados/",
			},
			{
				label: "Pasadena",
				url: "https://www.fincaraiz.com.co/blog/pasadena/",
			},
			{
				label: "Bella Suiza",
				url: "https://www.fincaraiz.com.co/blog/barrio-bella-suiza/",
			},
			{
				label: "Lagos de Cordoba",
				url: "https://www.fincaraiz.com.co/blog/barrio-lagos-de-cordoba/",
			},
			{
				label: "Niza",
				url: "https://www.fincaraiz.com.co/blog/barrio-niza-bogota-suba/",
			},
			{
				label: "Pinar de suba",
				url: "https://www.fincaraiz.com.co/blog/pinar-de-suba-bogota-conectividad/",
			},
		],
	},
	{
		city: "Medellín",
		image: CITY_IMAGES.medellin,
		imageUrl: CITY_IMAGE_BLOG_URLS.medellin,
		cityUrl: CITY_BLOG_URLS.medellin,
		neighborhoods: [
			{
				label: "El Poblado",
				url: "https://www.fincaraiz.com.co/blog/el-poblado-vida-residencial/",
			},
			{
				label: "Laureles",
				url: "https://www.fincaraiz.com.co/blog/laureles-lo-tiene-todo-a-la-mano/",
			},
			{
				label: "Belén",
				url: "https://www.fincaraiz.com.co/blog/conectividad-y-rutina-vecinal-en-belen/",
			},
			{
				label: "La Candelaria",
				url: "https://www.fincaraiz.com.co/blog/la-candelaria-motor-comercial/",
			},
			{
				label: "Las Palmas",
				url: "https://www.fincaraiz.com.co/blog/las-palmas-vida-tranquila-en-medellin/",
			},
			{
				label: "Miravalle",
				url: "https://www.fincaraiz.com.co/blog/barrio-miravalle-guayabal/",
			},
			{
				label: "Buenos Aires",
				url: "https://www.fincaraiz.com.co/blog/expansion-residencial-en-buenos-aires/",
			},
			{
				label: "Tesoro",
				url: "https://www.fincaraiz.com.co/blog/el-poblado-vida-residencial/",
			},
			{
				label: "Guayabal",
				url: "https://www.fincaraiz.com.co/blog/guayabal-un-barrio-conectado/",
			},
			{
				label: "Castropol",
				url: "https://www.fincaraiz.com.co/blog/castropol-en-medellin/",
			},
			{
				label: "Nogal",
				url: "https://www.fincaraiz.com.co/blog/laureles-nogal-medellin/",
			},
			{
				label: "La Florida",
				url: "https://www.fincaraiz.com.co/blog/barrio-la-florida-de-medellin/",
			},
			{
				label: "Robledo",
				url: "https://www.fincaraiz.com.co/blog/robledo-tradicion-comunitaria/",
			},
			{
				label: "Rodeo Alto",
				url: "https://www.fincaraiz.com.co/blog/barrio-rodeo-alto/",
			},
			{
				label: "Patio Bonito",
				url: "https://www.fincaraiz.com.co/blog/conoce-barrio-patio-bonito-en-medellin/",
			},
			{
				label: "Asomadero II",
				url: "https://www.fincaraiz.com.co/blog/asomadera-ii-entorno-residencial-vista/",
			},
			{
				label: "San Javier",
				url: "https://www.fincaraiz.com.co/blog/san-javier-conectividad-y-rutina-real/",
			},
			{
				label: "El Diamante",
				url: "https://www.fincaraiz.com.co/blog/el-diamante-robledo/",
			},
			{
				label: "La Aguacatala",
				url: "https://www.fincaraiz.com.co/blog/barrio-la-aguacatala-en-medellin/",
			},
			{
				label: "Belen Alameda",
				url: "https://www.fincaraiz.com.co/blog/barrio-belen-alameda/",
			},
			{
				label: "Conquistadores",
				url: "https://www.fincaraiz.com.co/blog/barrio-conquistadores-en-medellin/",
			},
			{
				label: "Lomas del Indio",
				url: "https://www.fincaraiz.com.co/blog/loma-del-indio-viviendas-comodas/",
			},
			{
				label: "La Castellana",
				url: "https://www.fincaraiz.com.co/blog/barrio-la-castellana-medellin/",
			},
			{
				label: "El Castillo",
				url: "https://www.fincaraiz.com.co/blog/el-castillo-exclusividad-en-las-montanas/",
			},
			{
				label: "Los Colores",
				url: "https://www.fincaraiz.com.co/blog/los-colores-laureles-vivir/",
			},
			{
				label: "Belen Malibu",
				url: "https://www.fincaraiz.com.co/blog/belen-malibu-guayabal/",
			},
			{
				label: "Boston",
				url: "https://www.fincaraiz.com.co/blog/barrio-boston-en-medellin/",
			},
			{
				label: "Astorga",
				url: "https://www.fincaraiz.com.co/blog/astorga-en-medellin-zona/",
			},
			{
				label: "Santa Rosa de Lima",
				url: "https://www.fincaraiz.com.co/blog/santa-rosa-de-lima-en-medellin/",
			},
			{
				label: "Villa Carlota",
				url: "https://www.fincaraiz.com.co/blog/villa-carlota-en-medellin/",
			},
			{
				label: "Perpetuo Socorro",
				url: "https://www.fincaraiz.com.co/blog/barrio-perpetuo-socorro/",
			},
			{
				label: "Aranjuez",
				url: "https://www.fincaraiz.com.co/blog/aranjuez-conectividad-parques-y-vecindad/",
			},
			{
				label: "Villa Hermosa",
				url: "https://www.fincaraiz.com.co/blog/guia-practica-de-vida-en-villa-hermosa/",
			},
			{
				label: "La America",
				url: "https://www.fincaraiz.com.co/blog/tradicion-residencial-en-la-america/",
			},
			{
				label: "Estadio",
				url: "https://www.fincaraiz.com.co/blog/estadio-vivir-en-laureles/",
			},
			{
				label: "Bolivariana",
				url: "https://www.fincaraiz.com.co/blog/barrio-bolivariana-medellin/",
			},
			{
				label: "San Lucas",
				url: "https://www.fincaraiz.com.co/blog/barrio-san-lucas-en-medellin/",
			},
			{
				label: "Florida Nueva",
				url: "https://www.fincaraiz.com.co/blog/florida-nueva-medellin/",
			},
			{
				label: "Sudamericana",
				url: "https://www.fincaraiz.com.co/blog/barrio-suramericana-en-laureles/",
			},
			{
				label: "La Gloria",
				url: "https://www.fincaraiz.com.co/blog/la-gloria-vida-residencial-junto-a-la-80/",
			},
			{
				label: "Doce de Octubre",
				url: "https://www.fincaraiz.com.co/blog/doce-de-octubre-vida-familiar/",
			},
			{
				label: "Popular",
				url: "https://www.fincaraiz.com.co/blog/popular-conectividad-y-rutina-de-montana/",
			},
			{
				label: "Castilla",
				url: "https://www.fincaraiz.com.co/blog/castilla-tradicon-indsutrial-y-vecinal/",
			},
			{
				label: "Manrique",
				url: "https://www.fincaraiz.com.co/blog/manrique-tradicion-vecinal/",
			},
			{
				label: "Santa Cruz",
				url: "https://www.fincaraiz.com.co/blog/santa-cruz-donde-todo-te-queda-cerca/",
			},
		],
	},
	{
		city: "Cali",
		image: CITY_IMAGES.cali,
		imageUrl: CITY_IMAGE_BLOG_URLS.cali,
		cityUrl: CITY_BLOG_URLS.cali,
		neighborhoods: [
			{
				label: "Comuna 1",
				url: "https://www.fincaraiz.com.co/blog/como-es-vivir-en-la-comuna-1-en-cali/",
			},
			{
				label: "Comuna 2",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-2-en-cali/",
			},
			{
				label: "Comuna 3",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-3-en-cali/",
			},
			{
				label: "Comuna 4",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-4-en-cali/",
			},
			{
				label: "Comuna 5",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-5-en-cali/",
			},
			{
				label: "Comuna 6",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-6-en-cali/",
			},
			{
				label: "Comuna 7",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-7-en-cali/",
			},
			{
				label: "Comuna 8",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-8-en-cali/",
			},
			{
				label: "Comuna 9",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-9-en-cali/",
			},
			{
				label: "Comuna 10",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-10-en-cali/",
			},
			{
				label: "Comuna 11",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-11-en-cali/",
			},
			{
				label: "Comuna 12",
				url: "https://www.fincaraiz.com.co/blog/vivir-comuna-12-en-cali-el-rodeo/",
			},
			{
				label: "Comuna 13",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-13-en-cali/",
			},
			{
				label: "Comuna 14",
				url: "https://www.fincaraiz.com.co/blog/vivir-comuna-14-en-cali/",
			},
			{
				label: "Comuna 15",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-comuna-15-en-cali/",
			},
			{
				label: "Comuna 16",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-comuna-16-en-cali/",
			},
			{
				label: "Comuna 17",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-17-en-cali/",
			},
			{
				label: "Comuna 18",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-18-en-cali/",
			},
			{
				label: "Comuna 19",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-la-comuna-19-en-cali/",
			},
			{
				label: "Comuna 20",
				url: "https://www.fincaraiz.com.co/blog/vivir-comuna-20-en-cali/",
			},
			{
				label: "Comuna 21",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-comuna-21-en-cali/",
			},
			{
				label: "Comuna 22",
				url: "https://www.fincaraiz.com.co/blog/vivir-en-comuna-22-en-cali/",
			},
			{
				label: "Bochalema",
				url: "https://www.fincaraiz.com.co/blog/crecimiento-residencial-bochalema/",
			},
			{
				label: "Pance",
				url: "https://www.fincaraiz.com.co/blog/pance-cali/",
			},
			{
				label: "Ciudad Jardin",
				url: "https://www.fincaraiz.com.co/blog/ciudad-jardin-cali-comuna-22/",
			},
			{
				label: "Bellavista",
				url: "https://www.fincaraiz.com.co/blog/bellavista-cali-un-mirador-privilegiado/",
			},
			{
				label: "Ciudad Campestre",
				url: "https://www.fincaraiz.com.co/blog/ciudad-campestre-en-cali-comuna-22/",
			},
			{
				label: "Cristales",
				url: "https://www.fincaraiz.com.co/blog/cristales-barrio-residencial-tranquilo/",
			},
			{
				label: "Santa Teresita",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-santa-teresita-exclusividad-residencial-y-entorno-tranquilo-en-la-comuna-2-de-cali/",
			},
			{
				label: "La Flora",
				url: "https://www.fincaraiz.com.co/blog/la-flora-desarrollo-norte-de-cali/",
			},
			{
				label: "Santa Mónica",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-santa-monica-ubicacion-estrategica-y-vida-residencial-en-el-norte-de-cali/",
			},
			{
				label: "San Pedro",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-san-pedro-tradicion-actividad-comercial-y-ubicacion-estrategica-en-la-comuna-3-de-cali/",
			},
			{
				label: "Villa Fátima",
				url: "https://www.fincaraiz.com.co/blog/villa-fatima-cali-comuna-22/",
			},
			{
				label: "Cañasgordas",
				url: "https://www.fincaraiz.com.co/blog/canasgordas-cali-comuna-22/",
			},
			{
				label: "Parcelación Piedra Grande",
				url: "https://www.fincaraiz.com.co/blog/parcelacion-piedra-grande-cali-comuna-22/",
			},
			{
				label: "San Vicente",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-san-vicente-ubicacion-estrategica-y-dinamica-urbana-en-la-comuna-2-de-cali/",
			},
			{
				label: "Arboledas",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-arboledas-entorno-residencial-tranquilo-y-ubicacion-estrategica-en-cali/",
			},
			{
				label: "Normandía",
				url: "https://www.fincaraiz.com.co/blog/como-se-vive-en-normandia-occidental/",
			},
			{
				label: "San Fernando Viejo",
				url:
					"https://www.fincaraiz.com.co/blog/san-fernando-viejo-cali-tradicion-brisa-y-elegancia-en-la-loma/",
			},
			{
				label: "Granada",
				url:
					"https://www.fincaraiz.com.co/blog/granada-tradicion-gastronomia-y-vida-urbana-en-el-norte-de-cali/",
			},
			{
				label: "Versalles",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-versalles-dinamica-comercial-y-ubicacion-estrategica-en-el-norte-de-cali/",
			},
			{
				label: "Junambú",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-juanambu-exclusividad-residencial-y-vida-urbana-cerca-del-oeste-de-cali/",
			},
			{
				label: "Santa Isabel",
				url:
					"https://www.fincaraiz.com.co/blog/santa-isabel-tradicion-salud-y-conectividad/",
			},
			{
				label: "Miraflores",
				url:
					"https://www.fincaraiz.com.co/blog/miraflores-exclusividad-en-los-cerros-con-la-mejor-vista-y-valorizacion-del-oeste-de-cali/",
			},
			{
				label: "Tequendama",
				url:
					"https://www.fincaraiz.com.co/blog/tequendama-motor-empresarial-y-servicios-del-sur-de-cali/",
			},
			{
				label: "Seminario",
				url:
					"https://www.fincaraiz.com.co/blog/seminario-exclusividad-y-naturaleza-en-el-balcon-residencial-mas-tranquilo-de-cali-2/",
			},
			{
				label: "El Peñon",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-el-penon-valorizacion-cultura-urbana-y-ubicacion-estrategica-en-la-comuna-3-de-cali/",
			},
			{
				label: "San Nicolas",
				url:
					"https://www.fincaraiz.com.co/blog/barrio-san-nicolas-tradicion-comercial-y-ubicacion-estrategica-en-el-centro-de-cali/",
			},
		],
	},
	{
		city: "Barranquilla",
		image: CITY_IMAGES.barranquilla,
		imageUrl: CITY_IMAGE_BLOG_URLS.barranquilla,
		cityUrl: CITY_BLOG_URLS.barranquilla,
		neighborhoods: [
			{
				label: "Riomar",
				url: "https://www.fincaraiz.com.co/blog/riomar-barranquilla-desarrollo-urbano/",
			},
			{
				label: "Norte-Centro Histórico",
				url: "https://www.fincaraiz.com.co/blog/norte-centro-historico-barranquilla/",
			},
			{
				label: "Metropolitana",
				url: "https://www.fincaraiz.com.co/blog/metropolitana-desarrollo-inmobiliario/",
			},
			{
				label: "Suroriente",
				url: "https://www.fincaraiz.com.co/blog/suroriente-barrios-mercado-inmobiliario/",
			},
			{
				label: "Suroccidente",
				url: "https://www.fincaraiz.com.co/blog/suroccidente-mercado-inmobiliario/",
			},
			{
				label: "El Prado",
				url: "https://www.fincaraiz.com.co/blog/el-prado-historica-y-arquitectura/",
			},
			{
				label: "Ciudad Jardin",
				url: "https://www.fincaraiz.com.co/blog/ciudad-jardin-barrio-tranquilo-y-seguro/",
			},
			{
				label: "Villa Campestre",
				url: "https://www.fincaraiz.com.co/blog/villa-campestre-zona-residencial/",
			},
			{
				label: "Alameda del Rio",
				url: "https://www.fincaraiz.com.co/blog/alameda-del-rio-un-nuevo-estilo-de-vida/",
			},
			{
				label: "Miramar",
				url: "https://www.fincaraiz.com.co/blog/miramar-zona-residencial-de-barranquilla/",
			},
			{
				label: "Villa Country",
				url: "https://www.fincaraiz.com.co/blog/villa-country-tradicion-y-comodidad/",
			},
			{
				label: "La Campiña",
				url: "https://www.fincaraiz.com.co/blog/la-campina-aire-puro-y-calidad-de-vida/",
			},
			{
				label: "Pastoral Social",
				url: "https://www.fincaraiz.com.co/blog/pastoral-social-seguridad-y-valorizacion/",
			},
			{
				label: "La Cumbre",
				url: "https://www.fincaraiz.com.co/blog/la-cumbre-el-balcon-de-barranquilla/",
			},
			{
				label: "Olaya Herrera",
				url: "https://www.fincaraiz.com.co/blog/olaya-herrera-el-epicentro-estrategico/",
			},
			{
				label: "Chiquinquira",
				url: "https://www.fincaraiz.com.co/blog/chiquinquira/",
			},
			{
				label: "Mequejo",
				url: "https://www.fincaraiz.com.co/blog/mequejo-el-sector-con-mayor-proyeccion/",
			},
			{
				label: "San Isidro",
				url: "https://www.fincaraiz.com.co/blog/san-isidro-valorizacion-ubicacion/",
			},
			{
				label: "Alfonso Lopez",
				url: "https://www.fincaraiz.com.co/blog/alfonso-lopez-con-gran-potencial/",
			},
			{
				label: "La Paz",
				url: "https://www.fincaraiz.com.co/blog/la-paz-barranquilla-lo-tiene-todo/",
			},
			{
				label: "San Pedro",
				url: "https://www.fincaraiz.com.co/blog/san-pedro-alejandrino-sector-estrategico/",
			},
			{
				label: "Alto Prado",
				url: "https://www.fincaraiz.com.co/blog/alto-prado-buena-ubicacion/",
			},
			{
				label: "Buenos Aires",
				url: "https://www.fincaraiz.com.co/blog/buenos-aires/",
			},
			{
				label: "Simon Bolivar",
				url: "https://www.fincaraiz.com.co/blog/simon-bolivar/",
			},
			{
				label: "Centro",
				url: "https://www.fincaraiz.com.co/blog/centro-de-barranquilla-punto-estrategico/",
			},
			{
				label: "Santa Helena",
				url: "https://www.fincaraiz.com.co/blog/santa-helena/",
			},
			{
				label: "San Nicolas",
				url: "https://www.fincaraiz.com.co/blog/san-nicolas/",
			},
			{
				label: "Pasadena",
				url: "https://www.fincaraiz.com.co/blog/pasadena/",
			},
			{
				label: "Laureles",
				url: "https://www.fincaraiz.com.co/blog/los-laureles/",
			},
			{
				label: "La Magdalena",
				url: "https://www.fincaraiz.com.co/blog/la-magdalena/",
			},
			{
				label: "Las Palmas",
				url: "https://www.fincaraiz.com.co/blog/las-palmas/",
			},
			{
				label: "Barrio Veinte",
				url: "https://www.fincaraiz.com.co/blog/barrio-veinte-de-julio-barranquilla/",
			},
			{
				label: "Ciudadela",
				url: "https://www.fincaraiz.com.co/blog/ciudadela-veinte-de-julio-barranquilla/",
			},
			{
				label: "La Sierra",
				url: "https://www.fincaraiz.com.co/blog/la-sierra-barranquilla-metropolitana/",
			},
			{
				label: "Kennedy",
				url: "https://www.fincaraiz.com.co/blog/barrio-kennedy-barranquilla/",
			},
			{
				label: "Santa Maria",
				url: "https://www.fincaraiz.com.co/blog/barrio-santa-maria-barranquilla/",
			},
			{
				label: "Las Americas",
				url: "https://www.fincaraiz.com.co/blog/las-americas-barranquilla-metropolitana/",
			},
			{
				label: "San Luis",
				url: "https://www.fincaraiz.com.co/blog/barrio-san-luis-barranquilla/",
			},
			{
				label: "San Jose",
				url: "https://www.fincaraiz.com.co/blog/san-jose-barranquilla-metropolitana/",
			},
			{
				label: "Cevillar",
				url: "https://www.fincaraiz.com.co/blog/cevillar-barranquilla-metropolitana/",
			},
			{
				label: "Santa Paula",
				url: "https://www.fincaraiz.com.co/blog/santa-paula-el-corazon-de-usaquen/",
			},
		],
	},
];
